export default __webpack_public_path__ + "static/media/wiles.818b1568.png";